export default (props = {}) => {
    const globalAdsConfig = (window.espn.ads && window.espn.ads.config) || {};
    const globalKvpsMap = globalAdsConfig.kvps.reduce((total, current) => {
        total[current.name] = current.value;
        return total;
    }, {});

    const { ads } = props;
    if (ads) {
        const localAdsConfig = ads.config;
        const combinedKvpsMap = { ...globalKvpsMap, ...localAdsConfig.kvps };
        const combinedKvpsArray = Object.keys(combinedKvpsMap || {}).map((name) => ({
            name,
            value: combinedKvpsMap[name]
        }));

        delete globalAdsConfig.breakpoints;
        const adConfig = {
            ...globalAdsConfig,
            disableInitialLoad: true,
            kvps: combinedKvpsArray,
            level: localAdsConfig.level
        };
        return adConfig;
    }
    return {};
};



// WEBPACK FOOTER //
// ./app/ads/util/getMergedAdConfig.js